import { render, staticRenderFns } from "./tunnel.vue?vue&type=template&id=5b352ad8&"
import script from "./tunnel.vue?vue&type=script&lang=js&"
export * from "./tunnel.vue?vue&type=script&lang=js&"
import style0 from "./tunnel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports